import { h, Component } from 'preact';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import * as BaseComp from 'components/bolt/tiledItems/tiledItems.js';
import Tile from 'components/bolt/tiledItems/tile/tile';
import Store from 'store/store';
import 'store/bolt/tiledItems';
import { getSizeOverride } from 'utils/bolt/index';
import s from 'components/bolt/tiledItems/tiledItems.sss';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';

export default class TiledItems extends BaseComp.default {

	componentDidMount(...args) {
		super.componentDidMount?.(...args);
		observeScroll(this.base);
	}

	componentWillUnmount(...args) {
		super.componentWillUnmount?.(...args);
		unobserveScroll(this.base);
	}

	getTilesArray() {
		const isDesktopSize = this.props?.client?.isDesktopSize;
		let tilesArray = Object.values(accessNested(this.props, `appData.pages.${this.props.id}.data.tiles`, {}));
		if (!tilesArray.length) return;

		if (tilesArray.length === 1) {
			const tileData = sortObjectByOrder(tilesArray[0].tilesData);
			const numberOfRows = tileData.length;
			const hasMultipleRows = numberOfRows > 2;

			if (hasMultipleRows) {
				let newTilesArray = [];
				for (let i = (Math.round(numberOfRows / 3)); i > 0; i--) {
					newTilesArray.push({
						tilesData: tileData.splice(0, Math.ceil(tileData.length / i)),
						orientation: tilesArray[0].orientation
					});
				}

				tilesArray = newTilesArray;
			} else {
				tilesArray = [{
					tilesData: tileData,
					orientation: tilesArray[0].orientation
				}];
			}
		}

		this.setState({ tilesArray });

		const isSection = this.props.appData.pages[this.props.id]?.section;
		const needsFooterShadow = isDesktopSize ? tilesArray.length % 2 === 0 : tilesArray[tilesArray.length - 1].tilesData.length % 2 === 0;

		if (!isSection) {
			Store.emit('ADD_TILED_ITEMS_FOOTER_SHADOW', needsFooterShadow);
		}
	}
	renderTiles() {
		const isDesktopSize = this.props?.client?.isDesktopSize;
		const { tilesArray, shortestTile } = this.state;

		const appData = this.props.appData;
		let fixedHeight = getSizeOverride(appData?.pages?.[this.props.id]?.data?.customTileSize);
		const height = fixedHeight || (shortestTile != undefined ? `${shortestTile}px` : '');

		const rows = isDesktopSize ? tilesArray : tilesArray.flatMap(row => row.tilesData.map(tile => ({ ...row, tilesData: [tile] })));

		return rows.map((items, index) => {
			const { tilesData, orientation } = items;
			const isPortrait = orientation === 'portrait';
			if (!tilesData) return;
			const rowData = sortObjectByOrder(tilesData).map((tile, i) => {
				return	(
					<Tile
						ref={e => this.$tileRefs[`tile${i}-${index}`] = e}
						data={tile}
						isPortrait={isPortrait}
						isEvenRow={index % 2 === 0}
						height={height}
					/>
				);
			});

			return (
				<div class={s.row}>
					<div class={joinClasses(s.tiles, isPortrait && s.portraitTiles)}>
						{rowData}
					</div>
				</div>
			);
		}).filter(item => item);
	}
}